import { Link, NavLink } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { useState } from "react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/all-results", label: "All Results" },
  { to: "/about", label: "About" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="sticky top-0 z-50 bg-neutral-950 text-white border-b border-neutral-800"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <img
            src="/logo-192.png"
            alt="Juwai Teer"
            width={44}
            height={44}
            className="w-11 h-11 rounded-full ring-1 ring-red-500/40 shadow-lg shadow-red-900/40 object-cover"
            data-testid="brand-logo"
          />
          <div className="leading-tight">
            <div className="font-heading font-black text-2xl sm:text-3xl tracking-tight">JUWAI TEER</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-yellow-400 font-semibold">
              A to Z Teer Office Result
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-semibold tracking-wide rounded-md transition-colors ${
                  isActive ? "text-white bg-neutral-800" : "text-neutral-300 hover:text-white hover:bg-neutral-900"
                }`
              }
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden sm:inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-600/15 border border-red-600/40 text-red-400 text-xs font-bold uppercase tracking-widest">
            <span className="w-2 h-2 rounded-full bg-red-500 live-dot" />
            Live
          </div>
          <button
            className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-lg bg-neutral-900 hover:bg-neutral-800"
            onClick={() => setOpen((s) => !s)}
            aria-label="Menu"
            data-testid="mobile-menu-btn"
          >
            {open ? <X size={20} weight="bold" /> : <List size={20} weight="bold" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-neutral-800 bg-neutral-950" data-testid="mobile-menu">
          <div className="px-4 py-3 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 text-sm font-semibold rounded-md ${
                    isActive ? "bg-neutral-800 text-white" : "text-neutral-300 hover:bg-neutral-900"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
